import { Font } from '@react-pdf/renderer';
import robotoSlabRegular from '../assets/fonts/RobotoSlab-Regular.ttf';
import robotoSlabMedium from '../assets/fonts/RobotoSlab-Medium.ttf';
import robotoSlabBold from '../assets/fonts/RobotoSlab-Bold.ttf';

// BluWave brand palette (BPP-215)
export const BRAND_PRIMARY = '#132543';
export const BRAND_GOLD = '#AB9151';

// Roboto Slab has no italic faces, so italic runs (e.g. review quotes) are mapped
// to the upright weights rather than left to react-pdf's variant resolution.
Font.register({
  family: 'Roboto Slab',
  fonts: [
    { src: robotoSlabRegular, fontWeight: 400 },
    { src: robotoSlabRegular, fontWeight: 400, fontStyle: 'italic' },
    { src: robotoSlabMedium, fontWeight: 500 },
    { src: robotoSlabBold, fontWeight: 700 },
    { src: robotoSlabBold, fontWeight: 700, fontStyle: 'italic' },
  ],
});

// react-pdf hyphenates words at the line break by default, which split ordinary prose
// mid-word ("ac-quired", "Responsibil-ities") in the narrow criteria-table columns. These
// are client-facing documents, so words wrap whole instead; returning the word unsplit is
// react-pdf's documented way to turn hyphenation off. Registered here so every PDF surface
// that imports the brand tokens gets it — the callback is global to react-pdf, not per-Document.
Font.registerHyphenationCallback((word) => [word]);

export const BRAND_FONT_FAMILY = 'Roboto Slab';
